import ActionTypes from "../constants/action_types";

export default function clearTopicTags(organisationId) {
  return {
    type: ActionTypes.TOPIC_TAGS_CLEAR.SUCCESS,
    organisation_id: organisationId,
  };
}
